import Loadable from 'components/Loadable';
import {
  MANAGEMENT_PATH,
  QUESTION_BANK_ADD_PATH,
  QUESTION_BANK_EDIT_PATH,
  QUESTION_BANK_PATH,
  QUESTION_BANK_VIEW_PATH,
  REPORT_PATH,
  REPORT_RESULT,
  ROOT,
  SUPPORT_PATH,
  SURVEY_ADD,
  SURVEY_EDIT,
  SURVEY_LIST_PATH,
  SURVEY_PREVIEW,
  USER_GROUP_PATH,
  USER_MANAGEMENT_PATH,
  SURVEY_VIEW,
  SURVEY_ADD_QUESTION,
  USER_CAMPAIGN_PATH,
  NO_PERMISSION_PATH,
  SURVEY_LIST_BY_USER,
} from 'constant/path';
import { lazy } from 'react';
import { Outlet } from 'react-router';
import QuestionBankProtectedWrapper from './QuestionBankProtectedWrapper';
import SurveyListProtectedWrapper from './SurveyListProtectedWrapper';
import ReportProtectedWrapper from './ReportProtectedWrapper';

const MainLayout = Loadable(lazy(() => import('layout/MainLayout')));
const SurveyAdd = Loadable(lazy(() => import('views/pages/survey/surveyAdd')));
const Management = Loadable(lazy(() => import('views/pages/systemManagement')));
const UserGroups = Loadable(lazy(() => import('views/pages/systemManagement/userGroups')));
const UserManagement = Loadable(lazy(() => import('views/pages/systemManagement/userManagement')));
const UserCampaign = Loadable(lazy(() => import('views/pages/systemManagement/userCampaign')));
const SurveyList = Loadable(lazy(() => import('views/pages/survey/index')));
const Report = Loadable(lazy(() => import('views/pages/report')));
const ReportResult = Loadable(lazy(() => import('views/pages/report/ReportResults')));
const Support = Loadable(lazy(() => import('views/pages/support')));
const QuestionBank = Loadable(lazy(() => import('views/pages/questionBank')));
const QuestionAdd = Loadable(lazy(() => import('views/pages/questionBank/questionAdd')));
const PreviewSurveyDevice = Loadable(
  lazy(() => import('views/pages/surveyList/previewSurveyDevice'))
);
const NoPermission = Loadable(lazy(() => import('views/pages/NoPermission')));
const SurveyListByUser = Loadable(lazy(() => import('views/pages/SurveyListByUser')));

const MainRoutes = {
  path: ROOT,
  element: <MainLayout />,
  children: [
    {
      path: MANAGEMENT_PATH,
      element: <Management />,
      children: [
        {
          path: USER_GROUP_PATH,
          element: <UserGroups />,
        },
        {
          path: USER_MANAGEMENT_PATH,
          element: <UserManagement />,
        },
        {
          path: USER_CAMPAIGN_PATH,
          element: <UserCampaign />,
        },
      ],
    },
    {
      path: QUESTION_BANK_PATH,
      element: (
        <QuestionBankProtectedWrapper>
          <Outlet />
        </QuestionBankProtectedWrapper>
      ),
      children: [
        {
          path: '',
          element: <QuestionBank />,
        },
        {
          path: QUESTION_BANK_ADD_PATH,
          element: <QuestionAdd />,
        },
        {
          path: QUESTION_BANK_EDIT_PATH,
          element: <QuestionAdd />,
        },
        {
          path: QUESTION_BANK_VIEW_PATH,
          element: <QuestionAdd />,
        },
      ],
    },
    {
      path: SURVEY_LIST_PATH,
      element: (
        <SurveyListProtectedWrapper>
          <Outlet />
        </SurveyListProtectedWrapper>
      ),
      children: [
        {
          path: '',
          element: <SurveyList />,
        },
        {
          path: SURVEY_ADD,
          element: <SurveyAdd />,
        },
        {
          path: SURVEY_ADD_QUESTION,
          element: <SurveyAdd />,
        },
        {
          path: SURVEY_EDIT,
          element: <SurveyAdd />,
        },
        {
          path: SURVEY_VIEW,
          element: <SurveyAdd />,
        },
        {
          path: SURVEY_PREVIEW,
          element: <PreviewSurveyDevice />,
        },
      ],
    },
    {
      path: REPORT_PATH,
      element: (
        <ReportProtectedWrapper>
          <Outlet />
        </ReportProtectedWrapper>
      ),
      children: [
        {
          path: '',
          element: <Report />,
        },
        {
          path: REPORT_RESULT,
          element: <ReportResult />,
        },
      ],
    },
    {
      path: SUPPORT_PATH,
      element: <Support />,
    },
  ],
};

export const WebviewLayout = {
  path: `${SURVEY_LIST_BY_USER}`,
  element: <SurveyListByUser />,
  children: [],
};

export default MainRoutes;
